// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1MW4g","title":"InfoRow_title__ikxfN"};